import { Auth } from 'aws-amplify';
import { clearDeviceLimitFlag } from './deviceLimitStorage';

export const performAmplifyGlobalSignout = async (): Promise<void> => {
  clearDeviceLimitFlag();
  await Auth.signOut({ global: true });
  window.location.href = '/signout' + window.location.search;
};
